import * as Scrivito from "scrivito";
import { buttonColors } from "^/config/attributeConsts";

const PageHeaderWidget = Scrivito.provideWidgetClass("PageHeaderWidget", {
  attributes: {
    destination: "link",
    headline: "string",
    subHeadline: "string",
    description: "html",
    image: ["reference", { only: "Image" }],
    background: ["reference", { only: ["Image", "Video"] }],
    backgroundColor: [
      "enum",
      {
        values: ["blue", "teal"],
      },
    ],
    buttonColor: [
      "enum",
      {
        values: buttonColors,
      },
    ],
  },
});

export default PageHeaderWidget;
